/**
 * Resolves user-facing error messages from API error responses using translation strings.
 */
import { translations } from "./translations";
function getBundle(lang) {
    const bundle = translations[lang];
    return bundle ?? translations.en;
}
/**
 * Extracts and formats error message from API error response.
 * Always uses translated messages from locale JSON (errors.genericError, errorCodes) — never the raw API message.
 *
 * Priority:
 * 1. If error code exists in errorCodes translations → use that message
 * 2. Otherwise → use errors.genericError
 */
export function getErrorMessageFromApiError(error, lang = "en") {
    const bundle = getBundle(lang);
    if (!error) {
        return bundle.errors.genericError;
    }
    const errorDetails = error?.data?.errorDetails ||
        error?.response?.data?.errorDetails ||
        error?.errorDetails ||
        error?.data;
    let errorCode;
    if (errorDetails) {
        if (Array.isArray(errorDetails) && errorDetails.length > 0) {
            errorCode = errorDetails[0]?.code;
        }
        else if (!Array.isArray(errorDetails) &&
            typeof errorDetails === "object" &&
            "code" in errorDetails) {
            errorCode = errorDetails.code;
        }
    }
    if (process.env.NODE_ENV === "development") {
        console.log("[getErrorMessageFromApiError]", {
            errorCode,
            lang,
            hasTranslation: errorCode
                ? !!bundle.errorCodes?.[errorCode]
                : false,
        });
    }
    const errorCodes = bundle
        .errorCodes;
    if (errorCode && errorCodes?.[errorCode]) {
        return errorCodes[errorCode];
    }
    return bundle.errors.genericError;
}
//# sourceMappingURL=getErrorMessageFromApiError.js.map